import { Box, Image, ImageProps, useColorMode } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

export type LogoProps = {
  variant?: "horizontal" | "vertical";
  w?: ImageProps["w"];
  h?: ImageProps["h"];
  mx?: ImageProps["mx"];
  my?: ImageProps["my"];
  style?: React.CSSProperties;
  className?: string;
  alt?: string;
  forceMode?: "light" | "dark";
  to?: string; // Route to navigate when clicked
};

const logoMap = {
  horizontal: {
    light: "/images/logo/light/horizontal.png",
    dark: "/images/logo/dark/horizontal.png",
  },
  vertical: {
    light: "/images/logo/light/vertical.png",
    dark: "/images/logo/dark/vertical.png",
  },
};

export const Logo = ({
  variant = "horizontal",
  w,
  h,
  mx,
  my,
  style,
  className,
  alt = "Logo",
  forceMode,
  to,
  ...rest
}: LogoProps) => {
  const { colorMode } = useColorMode();
  const navigate = useNavigate();
  const mode = forceMode || colorMode;
  const src = logoMap[variant][mode] || logoMap[variant].light;

  const handleClick = () => {
    if (to) {
      navigate(to);
    }
  };

  const ImageComponent = (
    <Image
      src={src}
      alt={alt}
      w={w}
      h={h}
      mx={mx}
      my={my}
      style={style}
      className={className}
      {...rest}
    />
  );

  if (to) {
    return (
      <Box
        onClick={handleClick}
        cursor="pointer"
        transition="opacity 0.2s"
        _hover={{ opacity: 0.8 }}
      >
        {ImageComponent}
      </Box>
    );
  }

  return ImageComponent;
};

export default Logo;
